<script lang="ts">
    import type {DirectoryInsight, RecordHolding} from 'typings/portaro.be.types';
    import {getInjector} from 'core/svelte-context/context';
    import {onMount} from 'svelte';
    import {KpAuthorityDetailPageService} from './kp-authority-detail-page.service';
    import {createPageContext} from 'shared/layouts/page-context';
    import KpLayoutBuilder from 'shared/layouts/grid-system/built-layout/KpLayoutBuilder.svelte';
    import KpAuthorityDetailHeadingPart from './parts/KpAuthorityDetailHeadingPart.svelte';
    import KpAuthorityDetailEditPanelPart from './parts/KpAuthorityDetailEditPanelPart.svelte';
    import KpAuthorityDetailHierarchyTreesPart from './parts/KpAuthorityDetailHierarchyTreesPart.svelte';
    import KpAuthorityDetailTabsetPart from './parts/KpAuthorityDetailTabsetPart.svelte';
    import KpAuthorityDetailSearchResultsPart from './parts/KpAuthorityDetailSearchResultsPart.svelte';
    import KpAuthorityDetailPermalinkPart from './parts/KpAuthorityDetailPermalinkPart.svelte';
    import KpAuthorityDetailDetailsPart from './parts/KpAuthorityDetailDetailsPart.svelte';
    import KpAuthorityDetailDividerPart from './parts/KpAuthorityDetailDividerPart.svelte';
    import KpLayoutGridContainer from 'shared/layouts/grid-system/KpLayoutGridContainer.svelte';
    import type {
        AuthorityDetailReactivePageData,
        AuthorityDetailStaticPageData,
        AuthorityDetailView,
        AuthorityHierarchyTree
    } from './types';

    export let view: AuthorityDetailView;

    const service = getInjector().getByClass(KpAuthorityDetailPageService);

    const authorityDetailComponents = {
        heading: KpAuthorityDetailHeadingPart,
        details: KpAuthorityDetailDetailsPart,
        hierarchyTrees: KpAuthorityDetailHierarchyTreesPart,
        tabset: KpAuthorityDetailTabsetPart,
        editPanel: KpAuthorityDetailEditPanelPart,
        divider: KpAuthorityDetailDividerPart,
        searchResults: KpAuthorityDetailSearchResultsPart,
        permalink: KpAuthorityDetailPermalinkPart
    };

    let directoryInsight: DirectoryInsight | undefined;
    let hierarchyTrees: AuthorityHierarchyTree[] | undefined;
    let recordHoldings: RecordHolding[] | undefined;

    const pageContext = createPageContext<AuthorityDetailStaticPageData, AuthorityDetailReactivePageData>(
        {model: view}, // Static
        {directoryInsight, hierarchyTrees, recordHoldings} // Reactive
    );

    onMount(async () => {
        [directoryInsight, hierarchyTrees, recordHoldings] = await Promise.all([
            service.getDirectoryInsight(view.record),
            service.getRecordHierarchyTrees(view.record),
            service.getRecordHoldings(view.record)
        ]);

        pageContext.updateReactiveData({directoryInsight, hierarchyTrees, recordHoldings});
    });
</script>

<KpLayoutGridContainer additionalClasses="kp-authority-detail-page" rowsWidth={view.layout.settings.defaultRowWidth}>
    <KpLayoutBuilder layout={view.layout} supportedComponents={authorityDetailComponents}/>
</KpLayoutGridContainer>

<style lang="less">
    :global {
        .kp-authority-detail-page .kp-search .kp-search-header-title {
            margin: 0;
        }
    }
</style>